import { axiosUser } from "@config/axiosConfig";
import { ProfilePayload, GSTDetailsPayload, SubmitOrganisationDetailsPayload } from "@modules/profile/types";

export const profileAPi = async () => {
  return await axiosUser.get("/profile", {});
};

export const editProfileAPI = async (payload: ProfilePayload) => {
  const { id, cin, tin } = payload; 
  return await axiosUser.put(`/edit/${id}`, {
    cin,
    tin,
  });
};

export const fetchGSTDetailsAPI = async (payload: GSTDetailsPayload) => {
  const { gst_number } = payload;
  return await axiosUser.post(`/fetch_gst_data`, {
    gst_number,
  });
};


export const submitUserRegistrationDetailsAPI = async (
  payload: any
) => {
  const {
    submitDetailsPayload,
    id,
  } = payload;
  return await axiosUser.put(`/edit/${id}`, {
    ...submitDetailsPayload,
  });
};

